import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SidloFirmy = {
	name: NAME,
	apiProvider,
	router,
};
